import Home from "./HomeCore";
import PageTransition from "../../components/PageTransition";

export default function HomeIndex() {
  return (
    <PageTransition>
      <Home />
    </PageTransition>
  );
}
